<template>
  <el-submenu :class="cssClass" :index="item.index">
    <template slot="title">
      <span>{{ $t(item.sectionName) }}</span>
    </template>
    <template v-for="subItem in filteredItems(item.subItems)">
      <nav-item :key="subItem.index" :item="subItem" css-class="level3" />
    </template>
  </el-submenu>
</template>
<script>
import navItem from '@/common/components/navigation/LeftNavigationItem'

export default {
  name: 'LeftNavigationSubMenu',

  components: { navItem },

  props: {
    item: {
      type: Object,
      required: true
    },
    icon: {
      type: Boolean,
      required: false
    },
    cssClass: {
      type: String,
      required: true
    },
    isCollapsed: {
      type: Boolean,
      required: false
    }
  },

  methods: {
    generateRoute(routeName) {
      return {
        name: routeName,
        query: { project_id: this.$store.getters.projectId }
      }
    },

    filteredItems(items) {
      return items.filter(
        item => !item.hasOwnProperty('isAllowed') || item.isAllowed(item)
      )
    }
  }
}
</script>
<style scoped>
.level1 >>> .el-submenu__title {
  height: 64px;
  line-height: 64px;
  color: #ffffff;
}

.level1 >>> .el-submenu__title i {
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
}

.level1-item {
  height: 64px;
  line-height: 64px;
}

.level1-item span {
  margin-left: 20px;
}

.level1 .level2 >>> .el-submenu__title {
  height: 48px;
  line-height: 48px;
}

.level2 span {
  padding-left: 45px;
}
</style>



// WEBPACK FOOTER //
// src/common/components/navigation/LeftNavigationSubMenu.vue